'use client'

import React from 'react';
import { useWorkflowContext } from '@/app/WorkflowContext';
import { RiGpsLine, RiGpsFill } from '@remixicon/react';
import { cx } from '@/lib/utils';

export type NFCStatus = 'idle' | 'scanning' | 'success' | 'error';


const statusStyles = {
    idle: 'text-gray-400',
    scanning: 'text-gray-400',
    success: 'text-green-500',
    error: 'text-red-500',
};

export function NFCHeaderIcon() {
    const { workflow } = useWorkflowContext();

    const nfcStatus: NFCStatus = workflow?.nfcScanStatus || 'idle';

    const defaultStyles = 'h-8 w-8 transition-colors duration-200';
    return <>
        {nfcStatus === 'idle' && <RiGpsLine
            className={cx(
                defaultStyles,
                statusStyles[nfcStatus]
            )}
        />}

        {(nfcStatus === 'scanning' || nfcStatus === 'success' || nfcStatus === 'error') && <RiGpsFill
            className={cx(
                defaultStyles,
                statusStyles[nfcStatus]
            )}
        />}
    </>;
}
